import axios from 'axios';
import { message } from 'antd';
import { authHeader } from '../util/api';

const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

export const TAGS_UPDATE_BEGIN = 'TAGS_UPDATE_BEGIN';
export const TAGS_UPDATE_SUCCESS = 'TAGS_UPDATE_SUCCESS';
export const TAGS_UPDATE_FAILURE = 'TAGS_UPDATE_FAILURE';
export const TAGS_DELETE_BEGIN = 'TAGS_DELETE_BEGIN';
export const TAGS_DELETE_SUCCESS = 'TAGS_DELETE_SUCCESS';
export const TAGS_DELETE_FAILURE = 'TAGS_DELETE_FAILURE';
export const TAGS_CREATE_BEGIN = 'TAGS_CREATE_BEGIN';
export const TAGS_CREATE_SUCCESS = 'TAGS_CREATE_SUCCESS';
export const TAGS_CREATE_FAILURE = 'TAGS_CREATE_FAILURE';
export const VENDOR_TAG_UPDATE_BEGIN = 'VENDOR_TAG_UPDATE_BEGIN';
export const VENDOR_TAG_UPDATE_SUCCESS = 'VENDOR_TAG_UPDATE_SUCCESS';
export const VENDOR_TAG_UPDATE_FAILURE = 'VENDOR_TAG_UPDATE_FAILURE';
export const VENDOR_TAGS_FETCH_BEGIN = 'VENDOR_TAGS_FETCH_BEGIN';
export const VENDOR_TAGS_FETCH_SUCCESS = 'VENDOR_TAGS_FETCH_SUCCESS';
export const VENDOR_TAGS_FETCH_FAILURE = 'VENDOR_TAGS_FETCH_FAILURE';

export const tagsUpdateBegin = (resource, id) => ({
  type: TAGS_UPDATE_BEGIN,
  meta: { resource, id }
});

export const tagsUpdateSuccess = (resource, id, entity) => ({
  type: TAGS_UPDATE_SUCCESS,
  payload: { entity },
  meta: { resource, id }
});

export const tagsUpdateFailure = (resource, id, error) => ({
  type: TAGS_UPDATE_FAILURE,
  payload: { error },
  meta: { resource, id }
});

export function updateTags({ resource, id, tagList }) {
  return (dispatch) => {
    dispatch(tagsUpdateBegin(resource, id));
    return axios
      .patch(`${BASE_API_URL}/${resource}/${id}/tags.json`,
        { tag_list: tagList },
        { headers: authHeader() })
      .then((json) => {
        dispatch(tagsUpdateSuccess(resource, id, json.data));
        return json.data;
      })
      .catch((error) => {
        dispatch(tagsUpdateFailure(resource, id, error));
        throw error;
      });
  };
}

export function mergeAvailableTags(prev = [], nextList = []) {
  return Array.from(new Set([...(prev || []), ...(nextList || [])])).sort();
}

export const tagsDeleteBegin = (resource, id) => ({
  type: TAGS_DELETE_BEGIN,
  meta: { resource, id }
});

export const tagsDeleteSuccess = (resource, id) => ({
  type: TAGS_DELETE_SUCCESS,
  meta: { resource, id }
});

export const tagsDeleteFailure = (resource, id, error) => ({
  type: TAGS_DELETE_FAILURE,
  payload: { error },
  meta: { resource, id }
});

export function deleteTag(id) {
  return (dispatch) => {
    const resource = 'vendor/tags';
    dispatch(tagsDeleteBegin(resource, id));
    return axios
      .delete(`${BASE_API_URL}/tags/${id}.json`, { headers: authHeader() })
      .then(() => {
        dispatch(tagsDeleteSuccess(resource, id));
        message.success('Tag deleted');
        dispatch(fetchVendorTags());
        return true;
      })
      .catch((error) => {
        dispatch(tagsDeleteFailure(resource, id, error));
        message.error('Failed to delete tag');
        throw error;
      });
  };
}

export const tagsCreateBegin = () => ({ type: TAGS_CREATE_BEGIN });
export const tagsCreateSuccess = () => ({ type: TAGS_CREATE_SUCCESS });
export const tagsCreateFailure = (error) => ({ type: TAGS_CREATE_FAILURE, payload: { error } });

export function createTags(tagList) {
  return (dispatch) => {
    dispatch(tagsCreateBegin());
    return axios
      .post(`${BASE_API_URL}/tags.json`, { tag_list: tagList }, { headers: authHeader() })
      .then(() => {
        dispatch(tagsCreateSuccess());
        message.success('Tags created successfully');
        dispatch(fetchVendorTags());
        return true;
      })
      .catch((error) => {
        dispatch(tagsCreateFailure(error));
        message.error('Failed to create tags');
        throw error;
      });
  };
}

export const vendorTagUpdateBegin = (id) => ({ type: VENDOR_TAG_UPDATE_BEGIN, meta: { id } });
export const vendorTagUpdateSuccess = (id, tag) => ({ type: VENDOR_TAG_UPDATE_SUCCESS, payload: { tag }, meta: { id } });
export const vendorTagUpdateFailure = (id, error) => ({ type: VENDOR_TAG_UPDATE_FAILURE, payload: { error }, meta: { id } });

export function updateTagName(id, name) {
  return (dispatch) => {
    dispatch(vendorTagUpdateBegin(id));
    return axios
      .put(`${BASE_API_URL}/tags/${id}.json`, { tag: { name } }, { headers: authHeader() })
      .then((json) => {
        dispatch(vendorTagUpdateSuccess(id, json.data));
        message.success('Tag updated');
        dispatch(fetchVendorTags());
        return json.data;
      })
      .catch((error) => {
        dispatch(vendorTagUpdateFailure(id, error));
        message.error('Failed to update tag');
        throw error;
      });
  };
}

export function fetchVendorTags(page = 1, perPage = 10, query = '') {
  return (dispatch) => {
    dispatch({ type: VENDOR_TAGS_FETCH_BEGIN });
    return axios
      .get(`${BASE_API_URL}/tags.json?page=${page}&per_page=${perPage}${query ? `&q[name_cont]=${encodeURIComponent(query)}` : ''}`,
        { headers: authHeader() })
      .then((json) => {
        const items = Array.isArray(json.data) ? json.data : json.data.tags || [];
        const total = json.data.total_entries || items.length;
        dispatch({ type: VENDOR_TAGS_FETCH_SUCCESS, payload: { items, total, page, perPage } });
        return items;
      })
      .catch((error) => {
        dispatch({ type: VENDOR_TAGS_FETCH_FAILURE, payload: { error } });
        return [];
      });
  };
}
